import { isValid } from "date-fns";
import * as yup from "yup";

import { getIntl } from "context/SettingsProvider";
import { ValidationError } from "yup";

export const AvailabilityValidationSchema = () => {
  const intl = getIntl();

  return yup.object({
    startTime: yup
      .string()
      .nullable()
      .test({
        name: "required",
        test: function (value) {
          if (!value) {
            const errors = [
              new ValidationError(
                intl.formatMessage({ id: "times.startDateRequired" }),
                value,
                "startDate",
              ),
            ];

            if (!this.parent.allDay) {
              errors.push(
                new ValidationError(
                  intl.formatMessage({ id: "times.startTimeRequired" }),
                  value,
                  "startTime",
                ),
              );
            }
            return this.createError({ message: () => errors });
          }
          return true;
        },
      })
      .test({
        name: "type",
        test: function (value) {
          if (value && !isValid(new Date(value))) {
            const errors = [
              new ValidationError(
                intl.formatMessage({ id: "validation.date" }),
                value,
                "startDate",
              ),
              new ValidationError(
                intl.formatMessage({ id: "validation.time" }),
                value,
                "startTime",
              ),
            ];
            return this.createError({ message: () => errors });
          }
          return true;
        },
      }),
    stopTime: yup
      .string()
      .nullable()
      .test({
        name: "required",
        test: function (value) {
          if (!value) {
            const errors = [
              new ValidationError(
                intl.formatMessage({ id: "times.endDateRequired" }),
                value,
                "endDate",
              ),
            ];

            if (!this.parent.allDay) {
              errors.push(
                new ValidationError(
                  intl.formatMessage({ id: "times.stopTimeRequired" }),
                  value,
                  "stopTime",
                ),
              );
            }
            return this.createError({ message: () => errors });
          }
          return true;
        },
      })
      .test({
        name: "type",
        message: intl.formatMessage({ id: "validation.time" }),
        test: function (value) {
          if (value && !isValid(new Date(value))) {
            const errors = [
              new ValidationError(intl.formatMessage({ id: "validation.date" }), value, "endDate"),
              new ValidationError(intl.formatMessage({ id: "validation.time" }), value, "stopTime"),
            ];
            return this.createError({ message: () => errors });
          }
          return true;
        },
      })
      .test({
        name: "min",
        test: function (value) {
          if (!!value && new Date(value) < new Date(this.parent.startTime)) {
            var errors: ValidationError[] = [];
            const endDateCopy = new Date(value);
            endDateCopy.setHours(0, 0, 0, 0);
            const startDateCopy = new Date(this.parent.startTime);
            startDateCopy.setHours(0, 0, 0, 0);

            if (endDateCopy < startDateCopy) {
              errors.push(
                new ValidationError(
                  intl.formatMessage({ id: "times.endDateAfterStartDate" }),
                  value,
                  "endDate",
                ),
              );
            }

            if (!this.parent.allDay) {
              errors.push(
                new ValidationError(
                  intl.formatMessage({ id: "times.endTimeAfterStartTime" }),
                  value,
                  "stopTime",
                ),
              );
            }

            return errors.length > 0 ? this.createError({ message: () => errors }) : true;
          }
          return true;
        },
      }),
  });
};
